import { render, staticRenderFns } from "./BetsElement.vue?vue&type=template&id=b9bc9610&scoped=true"
import script from "./BetsElement.vue?vue&type=script&lang=js"
export * from "./BetsElement.vue?vue&type=script&lang=js"
import style0 from "./BetsElement.vue?vue&type=style&index=0&id=b9bc9610&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9bc9610",
  null
  
)

export default component.exports